define('lib/Podio.UI.Header',['require','underscore','jquery','lib/jquery/jquery.hotkeys','jquery.cookie','mousetrap','react','react-dom','lib/Podio.Utils','component!NotificationHeaderDropdownComponent','component!settings/AccountSettingsModalComponent','component!Pricing/PricingOrganizationPickerComponent','component!KeyboardShortcutsModalComponent','views/header/Podio.Views.HeaderSearch','views/header/Podio.Views.HeaderDropdown','controllers/Podio.Controllers.SpaceSwitcher','controllers/conversations/Podio.Controllers.Conversations.Chat','lib/Podio.UI.Header.Counters','controllers/Podio.Controllers.FeatureTour','lib/Podio.UI.Tooltips','lib/Podio.Routes','lib/Podio.Event.UI','lib/Podio.Event','lib/Podio.Bootstrap','lib/GlobalEventBus','moment','lib/Podio.Time','models/Podio.Models.Organization','component!ContextualHelpPaneComponent','lib/backbone/Backbone.PodioEvents','controllers/conversations/Podio.Controllers.Conversations.New'],function (require) {
  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.hotkeys');
  require('jquery.cookie');

  var Mousetrap = require('mousetrap');

  var React = require('react');
  var ReactDOM = require('react-dom');

  var podioUtils = require('lib/Podio.Utils');

  var NotificationHeaderDropdown = React.createFactory(require('component!NotificationHeaderDropdownComponent'));

  var AccountSettingsModalComponent = React.createFactory(require('component!settings/AccountSettingsModalComponent'));
  var PricingOrganizationPickerComponent = React.createFactory(require('component!Pricing/PricingOrganizationPickerComponent'));
  var KeyboardShortcutsModalComponent = React.createFactory(require('component!KeyboardShortcutsModalComponent'));

  var ViewHeaderSearch = require('views/header/Podio.Views.HeaderSearch');
  // FIXME: Remove the actual code
  // var ViewHeaderHelp = require('views/header/Podio.Views.HeaderHelp');
  var ViewHeaderDropdown = require('views/header/Podio.Views.HeaderDropdown');

  var SpaceSwitcherController = require('controllers/Podio.Controllers.SpaceSwitcher');
  var ChatController = require('controllers/conversations/Podio.Controllers.Conversations.Chat');

  var HeaderCounters = require('lib/Podio.UI.Header.Counters');

  var FeatureTourController = require('controllers/Podio.Controllers.FeatureTour');

  var tooltips = require('lib/Podio.UI.Tooltips');
  var routes = require('lib/Podio.Routes');
  var eventUI = require('lib/Podio.Event.UI');
  var podioEvent = require('lib/Podio.Event');
  var bootstrap = require('lib/Podio.Bootstrap');

  var globalEvent = require('lib/GlobalEventBus');

  var moment = require('moment');
  var time = require('lib/Podio.Time');

  var OrganizationModel = require('models/Podio.Models.Organization');

  var ContextualHelpPaneComponent = React.createFactory(require('component!ContextualHelpPaneComponent'));
  var isInitial = true, eventBus = void 0, elmHeaderHelp = void 0;

  var elmUserOptionsNavigation, elmHeaderSpaceItem, elmSpaceSwitcher, elmDocument;
  var headerSearchView, headerHelpView, spaceSwitcherController;
  var chatController, elmChatButton, headerCounters, wrapper, isGlobalHome, wasInitialized;

  var searchDfd = $.Deferred();

  var tourController, elmHeaderGlobal, headerMyAccountView;

  var accountSettingsInstance, orgPickerInstance, _keyboardShortcutModalNode, _keyboardShortcutModalInstance;

  const MIN_SCREEN_WIDTH = 1150;

  function onDomReady() {
    if (wasInitialized === true) {
      return;
    }

    elmHeaderGlobal = $('#header-global');

    if ($('body').hasClass('layout-podio-narrow')) {
       hideUpgradeButtonAndNavigation(true);
    }

    elmUserOptionsNavigation = elmHeaderGlobal.find('.user-options-navigation');
    elmHeaderSpaceItem = elmHeaderGlobal.find('.space');
    elmSpaceSwitcher = elmHeaderGlobal.find('.space-switcher');
    elmHeaderGlobal.find('.search').on('click', onSpaceSwitcherShortcutTriggered);
    elmSpaceSwitcher.on('closed', onSpaceSwitcherClosed);

    elmDocument = $(document);

    headerMyAccountView = new ViewHeaderDropdown({
      el : elmHeaderGlobal.find('.navigation-link.my-account')
    });

    // Inbox counters
    HeaderCounters.initialize();

    if (podioUtils.loggedIn()) {
      // Global hotkeys
      _.defer(function() {
        elmDocument.bind('keydown', 's', onSearchShortcutTriggered);
        elmDocument.bind('keydown', 'c', onChatShortcutTriggered);
        elmDocument.bind('keydown', 'ctrl+shift+s', onSnowShortcutTriggered);
        elmDocument.bind('keydown', 'g', onSpaceSwitcherShortcutTriggered);

        // TODO: refactor keyboard shortcuts into its own file
        globalEvent.on('shortcut:help', onKeyboardShortcutTriggered);
        Mousetrap.bind("?", onKeyboardShortcutTriggered);
      });
    }

    if (bootstrap.hasBootstrapData("FeatureTourSettings")) {
      tourController = new FeatureTourController();
    }

    // Init chat pane
    initializeChatPane();

    var notificationsContainer = $('#header-global .inbox')[0];
    if (notificationsContainer) {
      ReactDOM.render(React.createElement(NotificationHeaderDropdown), notificationsContainer)  // TODO: Needs to be fixed from podio-ui 
    }

    wasInitialized = true;
  }

  function onAfterBundleLoaded() {
    _.defer(onDomReady);
  }

  function onKeyboardShortcutTriggered() {
    if (!_.isElement(_keyboardShortcutModalNode)) {
      _keyboardShortcutModalNode = document.body.appendChild(document.createElement('div'));
    }

    _keyboardShortcutModalInstance = ReactDOM.render(KeyboardShortcutsModalComponent(), _keyboardShortcutModalNode);
    _keyboardShortcutModalInstance.open();
  }

  function initSpaceSwitcher() {
    var elmSpaceSwitcherWrapper = elmHeaderGlobal.find('.space-switcher-wrapper');
    if (elmSpaceSwitcherWrapper.eq(0).length) {
      if (_.isUndefined(spaceSwitcherController)) {
        spaceSwitcherController = new SpaceSwitcherController({
          elmContainer: elmSpaceSwitcherWrapper
        });
      }
    }
  }

  function showSpaceSwithcer() {
    initSpaceSwitcher();

    spaceSwitcherController.showSpaceSwitcher();
  }

  function onSpaceSwitcherShortcutTriggered(evt) {
    evt.preventDefault();

    showSpaceSwithcer();
  }

  function onSpaceSwitcherClick(evt) {
    evt.stopImmediatePropagation();
    evt.stopPropagation();

    showSpaceSwithcer();
  }

  function initializeChatPane() {
    elmChatButton = elmHeaderGlobal.find('.podio-chat');
    var elmChatPane = $('.chat-pane');

    // don't initialize the chat if we are on a page with a different layout
    // which doesn't include the header
    if (!elmChatButton.length) {
      return false;
    }

    // don't initialize the chat if we are on the conversations page
    if (location.pathname === routes.html_conversations_path({format: ''})) {
      return false;
    }

    chatController = new ChatController({
      elmContainer: elmChatPane,
      headerCounters: HeaderCounters
    });

    chatController.bootup();

  }

  function hideUserNavigation() {
    elmUserOptionsNavigation.removeClass('active');
    elmUserOptionsNavigation.unbind('outsideclick', onUserNavigationOutsideClick);
  }

  function onSpaceSwitcherClosed() {
    elmHeaderSpaceItem.removeClass('open');
  }

  function onUserNavigationOutsideClick(e) {
    if ($(e.target).is('#header-global .user > a')) {
      return;
    }

    hideUserNavigation();
  }

  function onHeaderUserClicked(elmTarget, e) {
    if (elmUserOptionsNavigation.hasClass('active')) {
      hideUserNavigation();
    } else {
      elmUserOptionsNavigation.addClass('active');
      elmUserOptionsNavigation.bind('outsideclick', onUserNavigationOutsideClick);
    }
  }

  function getSlidePanelWidth() {
    if (_.isUndefined(elmHeaderGlobal)) {
      elmHeaderGlobal = $('#header-global');
    }

    // Find width of last column in grid
    var columnWidth = elmHeaderGlobal.width() * 0.2;

    if(!this.searchWidth) {
      this.searchWidth = elmHeaderGlobal.find('.podio-search').eq(0).outerWidth();
    }

    return columnWidth - this.searchWidth;
  }

  function collapseHeaderHelpView(){
    if (_.isDefined(headerHelpView)) {
      headerHelpView.collapse();
    }
  }

  function ensureHeaderSearch() {
    if (_.isUndefined(headerSearchView)) {
      headerSearchView = new ViewHeaderSearch({
        el : elmHeaderGlobal.find('.podio-search')
      });
      searchDfd.resolve(headerSearchView);
    }
  }

  function hideUpgradeButtonAndNavigation(hideNav) {
    elmHeaderGlobal = $('#header-global');
    elmUpgrade = elmHeaderGlobal.find('.user-functions.upgrade-section-tier');
      if (elmHeaderGlobal.width() < MIN_SCREEN_WIDTH) {
        if (elmUpgrade.length > 0) {
          elmUpgrade.hide();
        }
        if (hideNav) {
          $('#header-global').find('.user-navigation').hide();
        }
      }
  }

  function showUpgradeButtonAndNavigation(showNav) {
    elmHeaderGlobal = $('#header-global');
    elmUpgrade = elmHeaderGlobal.find('.user-functions.upgrade-section-tier');
      if (elmHeaderGlobal.width() < MIN_SCREEN_WIDTH) {
        if (elmUpgrade.length > 0) {
          elmUpgrade.show();
        }
        if (showNav) {
          $('#header-global').find('.user-navigation').show();
        }
      }
  }

  function onHeaderSearchIconClicked(elmTarget, e) {
    var panelWidth = getSlidePanelWidth();

    ensureHeaderSearch();

    headerSearchView.expand(panelWidth);
    collapseHeaderHelpView();
    headerMyAccountView.collapse();

    tooltips.hideAll();
    hideUpgradeButtonAndNavigation(false);
  }

  function onHeaderMyAccountClicked(elmTarget, e) {
    ensureHeaderSearch();

    headerMyAccountView.expand();
    headerSearchView.collapse();
    collapseHeaderHelpView();

    tooltips.hideAll();
  }

  function onHeaderAccountSettingsClicked(elmTarget, e) {
    e.preventDefault();

    var componentContainer = document.getElementById('modal-account-settings-placeholder');
    if (!componentContainer) {
      componentContainer = document.createElement('div');
      componentContainer.id = 'modal-account-settings-placeholder';

      document.body.appendChild(componentContainer);
    }

    if (_.isUndefined(accountSettingsInstance)) {
      accountSettingsInstance = ReactDOM.render(AccountSettingsModalComponent(), componentContainer);
    }

    accountSettingsInstance.open();
    headerMyAccountView.collapse();
  }

  function EventBus(options) {
    _.extend(this, options);

    return this;
  }

  _.extend(EventBus.prototype, require('lib/backbone/Backbone.PodioEvents'));

  function onHeaderHelpIconClicked(elmTarget, e) {
    if (_.isUndefined(elmHeaderHelp)) {
      elmHeaderHelp = elmHeaderGlobal.find('.podio-help');
    }


    if (_.isUndefined(eventBus)) {
      eventBus = new EventBus();
    }


    var helpPaneContainer = document.querySelector('.help-panes');
    var contextualHelpPaneContainer = document.getElementById('contextualHelpPane');
    if (!contextualHelpPaneContainer) {
      contextualHelpPaneContainer = document.createElement('section');
      contextualHelpPaneContainer.id = 'contextualHelpPane';
      helpPaneContainer.appendChild(contextualHelpPaneContainer);
    }

    var contextualHelpPaneComponent = ReactDOM.render(ContextualHelpPaneComponent({
      eventBus: eventBus,
      elmHeaderHelp: elmHeaderHelp
    }), contextualHelpPaneContainer);

    if (isInitial === false) {
      contextualHelpPaneComponent.setState({
        isOpen: !contextualHelpPaneComponent.state.isOpen
      });
    }

    isInitial = false;
  }

  function onMessageUEButtonClicked(elmTarget) {
    collapseHeaderHelpView();

    var ControllerConversationNew = require('controllers/conversations/Podio.Controllers.Conversations.New');
    ControllerConversationNew.showWithPrePopulate({
      userIds: [elmTarget.data('user-id')]
    });
  }

  function onSearchShortcutTriggered(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    onHeaderSearchIconClicked();
  }

  function onChatShortcutTriggered(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (chatController) {
      chatController.toggleChatPane(true);
    }

    return false;
  }

  function onSnowShortcutTriggered(e) {
    var elmHeader = $('#header-global');
    elmHeader.toggleClass('snow');
  }

  function onHeaderChatButtonClicked(elmTarget, e) {
    if (chatController) {
      chatController.toggleChatPane();
    }
    return false;
  }

  function onConversationNotificationClicked(elmTarget, e) {
    var conversationId = elmTarget.data('id');
    if (chatController) {
      elmTarget.remove();
      chatController.showConversationById(conversationId);
    }
  }

  function onUpgradeTierClick(elmTarget, e) {
    e.preventDefault();

    var componentContainer = document.getElementById('modal-org-picker-placeholder');
    if (!componentContainer) {
      componentContainer = document.createElement('div');
      componentContainer.id = 'modal-org-picker-placeholder';

      document.body.appendChild(componentContainer);
    }

    if (_.isUndefined(orgPickerInstance)) {
      orgPickerInstance = ReactDOM.render(PricingOrganizationPickerComponent(), componentContainer);
    }

    orgPickerInstance.open();
    headerMyAccountView.collapse();
  }

  isGlobalHome = $('#wrapper.home').length > 0 && $('#global_stream').length > 0;

  if (isGlobalHome) {
    podioEvent.bind(podioEvent.Types.onAfterBundleLoaded, onAfterBundleLoaded);
  } else if (document.body.classList.contains('items')) {
    globalEvent.on('item.main.ready', onAfterBundleLoaded);
    globalEvent.on('item.enterEditTemplate', onAfterBundleLoaded);
  } else {
    podioEvent.bind(podioEvent.Types.init, onDomReady);
  }

  eventUI.bind('click', '#header-global .user > a', onHeaderUserClicked);
  eventUI.bind('click', '#header-global .podio-search .icon', onHeaderSearchIconClicked);
  eventUI.bind('click', '#header-global .user-functions .my-account .icon', onHeaderMyAccountClicked);
  eventUI.bind('click', '#header-global .podio-help .icon', onHeaderHelpIconClicked);
  eventUI.bind('click', '#header-global .podio-help .ue-contact .message-button', onMessageUEButtonClicked);
  eventUI.bind('click', '#header-global .podio-chat', onHeaderChatButtonClicked);
  eventUI.bind('click', '.conversation-notification', onConversationNotificationClicked);

  eventUI.bind('click', '.upgrade-section-tier a', onUpgradeTierClick, true);
  eventUI.bind('click', '.my-account .pricing-tier', onUpgradeTierClick, true);
  eventUI.bind('click', '.promotion-banner a.upgrade_link', onUpgradeTierClick, true);
  eventUI.bind('click', '#header-global .user-functions .my-account .extension-vouchers', onHeaderAccountSettingsClicked);

  // Expose global method to open up the account settings modal for promotional purposes.
  // An anchor with href="javascript:window.openExtensionsModal()" will be used in a banner promotion,
  // specifically for Device Magic. Ask Pete Schulz for details.
  window.openExtensionsModal = function() {
    var componentContainer = document.getElementById('modal-account-settings-placeholder');
    if (!componentContainer) {
      componentContainer = document.createElement('div');
      componentContainer.id = 'modal-account-settings-placeholder';

      document.body.appendChild(componentContainer);
    }

    if (_.isUndefined(accountSettingsInstance)) {
      accountSettingsInstance = ReactDOM.render(AccountSettingsModalComponent(), componentContainer);
    }

    accountSettingsInstance.open();
  }

  $('body').on('classChange', function(event, hideElements) {
    if (hideElements) {
      hideUpgradeButtonAndNavigation(true);
    } else {
      showUpgradeButtonAndNavigation(true);
    }
  });

  return {
    Search: {
      waitForInstance: searchDfd
    },
    onDomReady: onDomReady
  };
});

